import React, { Component } from 'react';
import { Button } from 'antd';
import './SharedTable.scss';
import { store } from 'Store/store.index';
import intl from 'react-intl-universal';
import SharedModel from './SharedModel';
import {
  DELETE_SHARED_FILE_SUCCESS,
  DELETE_SHARED_FILE_FAILED,
  UNSHARE_FILE_FAILED,
  UNSHARE_FILE_SUCCESS,
} from 'Components/viewer/ui/constants/user.more.constants';
import { isSharedClound } from '@/api/index';
// import { error } from '@/../../../Library/Caches/typescript/4.2/node_modules/ajv/dist/vocabularies/applicator/dependencies';
import { REMOVE_MES, UNSHARE_FILES, DELETE_SHARED_FILES } from '../../viewer/ui/constants/event.constants.share';
// import { collaborationService } from '@/store/services/index';
export default class SharedBulkOperation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModel: false,
      modelDateils: {},
    };
  }
  hideModel = (e) => {
    e.stopPropagation();
    this.setState({ showModel: false });
  };
  showModel = (type) => {
    const baseText = 'collaboration.sharedList.SharedTableAction';
    const textMap = {
      Delete: {
        content: `该文档将从共享列表中移除。您想要继续吗？`,
        contentTitle: `确定移除？`,
        confirmText: `确定`,
        confirm: this.DeleteSharedFile,
      },
      Unshared: {
        content: '该文档将停止共享。您想要继续吗？',
        contentTitle: `确定取消共享？`,
        confirmText: `确定`,
        confirm: this.UnsharedFile,
      },
      RemoveMe: {
        contentTitle: `确定移除我？`,
        content: `如果您将自己移除了，该文件将从您的共享文件列表中删除。`,
        confirmText: `确定`,
        confirm: this.removeMeBatch,
      },
    };
    const { contentTitle, content, confirmText, confirm } = textMap[type];

    this.setState({
      showModel: true,
      modelDateils: {
        // title: intl.get(title),
        content,
        confirmText,
        cancelText: intl.get(`${baseText}.modelCancelBtnText`),
        confirm,
        contentTitle,
        cancel: this.hideModel,
      },
    });
    if (type == 'RemoveMe') {
      store.userStore.doSendGAEvent({ eventKey: REMOVE_MES, label: 'getting_started' });
    }
  };
  UnsharedFile = () => {
    const { selectList, updateData } = this.props;
    const promises = [];
    store.appStore.showLoading(true);
    selectList.map((item) => {
      //   promises.push(collaborationService.unshare(item.reviewSessionID));
      promises.push(store.collaborationStore.putShareReview({ reviewSessionID: item.reviewSessionID, shareState: 1 }));
    });
    Promise.all(promises)
      .then(
        () => {
          store.userStore.doSendGAEventByUserEvent(UNSHARE_FILE_SUCCESS, null, null);
          updateData && updateData();
        },
        () => {
          store.userStore.doSendGAEventByUserEvent(UNSHARE_FILE_FAILED, null, null);
        },
      )
      .finally(() => {
        store.appStore.showLoading(false);
      });
    store.userStore.doSendGAEvent({ eventKey: UNSHARE_FILES, label: 'getting_started' });
  };
  DeleteSharedFile = () => {
    const sendData = {
      delFlag: 1,
    };
    const successCallback = () => {
      store.userStore.doSendGAEventByUserEvent(DELETE_SHARED_FILE_SUCCESS, null, null);
    };
    const errorCallback = () => {
      store.userStore.doSendGAEventByUserEvent(DELETE_SHARED_FILE_FAILED, null, null);
    };
    this.putShareReviewBatch(sendData, true, successCallback, errorCallback);
    store.userStore.doSendGAEvent({ eventKey: DELETE_SHARED_FILES, label: 'getting_started' });
  };
  putShareReviewBatch = (options, initPage, successCallback, errorCallback) => {
    const { onChangeSetCurrentPage, selectList, updateData } = this.props;
    const sendData = {
      reviewSessionIDs: selectList.map((item) => item.reviewSessionID),
      ...options,
    };

    store.appStore.showLoading(true);
    store.collaborationStore
      .putShareReviewBatch(sendData)
      .then((res) => {
        store.appStore.showLoading(false);
        if (res.ret === 0) {
          initPage && onChangeSetCurrentPage && onChangeSetCurrentPage();
          updateData && updateData();
          successCallback && successCallback();
        }
      })
      .catch(() => {
        store.appStore.showLoading(false);
        errorCallback && errorCallback();
      });
  };
  removeMeBatch = () => {
    const { selectList, updateData } = this.props;
    const sendData = {
      reviewSessionIDs: selectList.map((item) => item.reviewSessionID),
      isJoin: 0,
    };
    store.collaborationStore.putShareReviewInviteParticipantBatch(sendData).then((res) => {
      if (res.ret === 0) {
        updateData && updateData();
      }
    });
  };
  render() {
    const { showModel, modelDateils } = this.state;
    const {
      type,
      // indeterminate,
      //  onCheckAllChange,
      //   checkAll,
      resetSelect,
      selectList,
    } = this.props;
    const isDisabled = selectList.length === 0 ? true : false;
    // const isEnableCheckAll = selectList.some((item) => {
    //   if (item.shareState === 0) {
    //     return true;
    //   }
    // });
    return (
      <div className="SharedBulkOperation">
        {/* <Checkbox disabled={!isEnableCheckAll} indeterminate={indeterminate} onChange={onCheckAllChange} checked={checkAll} className="allCheckBox" /> */}
        <div className="choose-num">已选 {selectList.length} 项</div>
        {type === 'yours' && !isSharedClound() && (
          <Button disabled={isDisabled} type="primary" shape="round" onClick={this.showModel.bind(this, 'Unshared')}>
            <i></i>
            {intl.get('collaboration.sharedList.SharedTableAction.UnshareFileBtn')}
          </Button>
        )}
        {type === 'yours' && isSharedClound() && (
          <Button disabled={isDisabled} type="primary" shape="round" onClick={this.showModel.bind(this, 'Unshared')}>
            <i></i> {intl.get('collaboration.sharedList.SharedBulkOperation.DeleteSharedFile')}
          </Button>
        )}
        {type === 'others' && (
          <Button disabled={isDisabled} type="primary" shape="round" onClick={this.showModel.bind(this, 'RemoveMe')}>
            <i></i> {intl.get('collaboration.sharedList.SharedBulkOperation.RemoveMe')}
          </Button>
        )}
        <div className="exit-check" onClick={resetSelect}>
          <i></i>
          退出多选
        </div>
        <SharedModel visible={showModel} detailsData={modelDateils} />
      </div>
    );
  }
}
